// ** Initial State
const initialState = {
    result_list: [],
    total: 0
}

const aiAgent = (state = initialState, action) => {
    switch (action.type) {
        case 'AI_AGENT_LIST':
            return {
                ...state,
                result_list: action.data,
                total: action.total
            }
        default:
            return { ...state }
    }
}

export {
    aiAgent
}
